<template>
  <div>
    <div class="container" v-if="fill_info == ''">
      <div class="row">
        <div class="col-xs-12 col-md-3">

          <div class="panels">
            <DocumentUploader ref="igazolasfeltolto"/>
          </div>
        </div>

        <!-- Űrlap -->
        <div class="col-xs-12 col-md-9">
          <div class="form-title">Külföldre ösztöndíjat nyert hallgatók útiköltségének támogatása</div>

          <!-- ------------------------------ Hallgató Adatok ------------------------------ -->

          <HallgatoAdatok v-on:onReady="(hallgato,hallgato_szakok) => {this.save_enabled = true;this.hallgato = hallgato;this.hallgato_szakok = hallgato_szakok}"></HallgatoAdatok>

          <h5 class="form-block-title-layout-tab">
            <span>Adószám, számlaszám</span>
          </h5>

          <div class="row">
            <div class="col-md-6">
              <inputbox :errors="errors" id="Adoszam" regexp_filter="[0-9-]+" label="Adóazonosító jel" name="Adoszam" v-model="form.Adoszam"/>
            </div>
            <div class="col-md-6">
              <inputbox :errors="errors" regexp_filter="[0-9]+" mask="99999999-99999999-99999999" iconclass="fa fa-pencil" id="Szamlaszam" label="Számlaszám" name="Szamlaszam" v-model="form.Szamlaszam"/>
            </div>
          </div>

          <!-- ------------------------------ Pályázati adatok ------------------------------ -->

          <h5 class="form-block-title-layout-tab">
            <span>Utazás adatai</span>
          </h5>

          <div class="row">
            <div class="col-md-6">
              <inputbox :errors="errors" id="FogadoOrszag" label="Fogadó ország" iconclass="fa fa-pencil" name="FogadoOrszag" v-model="form.FogadoOrszag"/>
              <inputbox :errors="errors" id="FogadoIntezmeny" label="Fogadó intézmény" iconclass="fa fa-pencil" name="FogadoIntezmeny" v-model="form.FogadoIntezmeny"/>
              <inputbox :errors="errors" id="Utikoltseg" regexp_filter="[0-9]+" label="Útiköltség" iconText="Ft" name="Utikoltseg" v-model="form.Utikoltseg"/>
            </div>
            <div class="col-md-6">
              <inputbox :errors="errors" id="FogadoVaros" label="Fogadó város" iconclass="fa fa-pencil" name="FogadoVaros" v-model="form.FogadoVaros"/>
              <div class="form-group">
                <label class="form-label">
                  Az utazás módja
                </label>
                <select class="form-control" name="UtazasModja" id="UtazasModja" v-model="form.UtazasModja">
                  <option v-for="(um, i) in utazasi_modok" :value="um.value">{{ um.text }}</option>
                </select>
                <div v-if="error.id == 'UtazasModja'" v-for="(error, i) in errors" class="form-error">{{ error.msg }}</div>
              </div>
            </div>
          </div>

          <div class="info-box warning">
            Az adatlaphoz mellékelni kell a pályázati kiírásban meghatározott igazolásokat. <span class="highlight">Az elszámolási kötelezettségeknek legkésőbb a 2018/2019-es tanév őszi szemeszterének utolsó napjáig kell eleget tenni.</span>
          </div>

          <div style="display: flex; justify-content: space-between; align-items: center">
            <button v-on:click="save" type="button" name="kuld" :disabled="!save_enabled" class="button">Beküld</button>
          </div>
        </div>

      </div>
    </div>
    <div class="container" v-show="fill_info != ''">
      <div class="row">
        <div class="col-xs-12">
          <div class="form-title">Külföldre ösztöndíjat nyert hallgatók útiköltségének támogatása</div>
          <div class="article-text" v-html="fill_info">{{ fill_info }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import HallgatoAdatok from './hatar_hallgato_adatok.vue';

export default {
  components: {
    HallgatoAdatok
  },

  data: function() {
    return {
      fill_info: '',
      save_enabled: false,
      errors: [],
      hallgato: {},
      hallgato_szakok: {},
      elemleirasok: [],
      form: {
        Adoszam: '',
        Szamlaszam: '',
        UtazasModja: 'Repülő',
        FogadoOrszag: '',
        FogadoVaros: '',
        FogadoIntezmeny: '',
        Utikoltseg: ''
      },
      utazasi_modok: [
        {
          value: 'Repülő',
          text: 'Repülő',
        },
        {
          value: 'Vonat',
          text: 'Vonat',
        },
        {
          value: 'Busz',
          text: 'Busz',
        },
        {
          value: 'Kombinált',
          text: 'Kombinált',
        }
      ]
    }
  },
  mounted: function() {
  	var _this = this;

    Vue.nextTick(function() {
      _this.urlapKitoltheto();
      _this.setPanels();
      _this.getElemleirasok();

      $(window).scroll(function() {
        _this.setPanels();
      });
    });
  },
  watch: {
  },
  methods: {
    urlapKitoltheto: function() {
      var _this = this;
      this.$root.ajax('hatar/urlap_kitoltheto/KulfoldiUtikoltsegPalyazat/' + this.$root.user.neptuncode, {
        method: 'GET',
        success: function(response) {
          if (response.error == false) {
            if (!response.kitoltheto)
              _this.fill_info = 'Az űrlap nem tölthető ki.';
          }
        }
      });
    },

    getTooltipDescriptionByKey: function(tkey) {
      var desc = '';
      this.elemleirasok.map(function(el) {
        if (el.tkey == tkey)
          desc = el.tooltip_description;
      });

      return desc;
    },

    getUploadDescriptionByKey: function(tkey) {
      var desc = '';
      this.elemleirasok.map(function(el) {
        if (el.tkey == tkey)
          desc = el.upload_description;
      });

      return desc;
    },

    getElemleirasok: function() {
      var _this = this;
      this.$root.ajax('hatar/elemleirasok/KulfoldiUtikoltseg', {
        method: 'GET',
        success: function(response) {
          _this.elemleirasok = response.elemleirasok;
          _this.addRequestedDocs();
        }
      });
    },

    addRequestedDocs: function() {
      this.$refs.igazolasfeltolto.newBlock('menetjegy','Menetjegy', this.getUploadDescriptionByKey('menetjegy'));
      this.$refs.igazolasfeltolto.newBlock('eltoltott_ido', 'A külföldi intézményben eltöltött idő.', this.getUploadDescriptionByKey('eltoltott_ido'));
      this.$refs.igazolasfeltolto.newBlock('szamla', 'Számla', this.getUploadDescriptionByKey('szamla'));
    },

    setPanels: function() {
      var h = $('header').outerHeight() + $('.subpage-head-image').outerHeight() + $('.submenu').outerHeight() + 40 - 20;
      if ($(window).scrollTop() >= h) {
        $('.panels').addClass('fixed').css('width', $('.panels').parents('div').width());
      } else {
        $('.panels').removeClass('fixed').css('width', 'auto');
      }

      // Ha a lábléc megjelenik, akkor a magasságból ki kell vonni a látható lábléc magasságát
      if (($(window).scrollTop() + $(window).innerHeight()) >= $('footer').offset().top) {
        $('.panels').css({
          'max-height': $(window).innerHeight() - 40 - (($(window).scrollTop() + $(window).innerHeight()) - $('footer').offset().top)
        });
      } else {
        $('.panels').css({
          'max-height': $(window).innerHeight() - 40
        });
      }
    },

    save: function() {
      var _this = this;

      this.errors = [];

      this.form.Szamlaszam = this.form.Szamlaszam.replace(/_/g, '');
      if (this.form.Szamlaszam.slice(-1) == '-') {
        this.form.Szamlaszam = this.form.Szamlaszam.slice(0, -1);
      }

      this.$root.ajax('hatar/ment/kulfoldi_utikoltseg_palyazat/', {
        method: 'POST',
        data: {
          form: this.form,
          all_files_uploaded: this.$refs.igazolasfeltolto.isAllFilesUpload(),
          blocks: this.$refs.igazolasfeltolto.getData(),
          hallgID: this.hallgato.HallgID
        },
        success: function(response) {
          if (response.errors != undefined && response.errors.length > 0) {
            _this.errors = response.errors;

            Vue.nextTick(function() {
              $('html, body').animate({
                scrollTop: $('#' + _this.errors[0].id).offset().top - 50
              }, 500);
            })

          } else if (response.error) {
            swal('Hiba!', response.error, 'error');

          } else {
            _this.fill_info = response.fill_info;
          }
        }
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// kulfoldi_utikoltseg_palyazat.vue?558d393a